module.exports = __webpack_public_path__ + "static/media/worn-by-the-best.7f1d93cf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/worn-by-the-best.mp4
// module id = 3558
// module chunks = 0